
import { motion } from "framer-motion";
import { Fragment, useMemo } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { useProfile } from "../../../contexts/ProfileContext.tsx";

interface MotionTableThProps {
    tituloColuna?: string;
    textoTituloColuna?: string;
}

const MotionTableTh = styled(motion.th) <MotionTableThProps>`
    padding-top: 4px;
    padding-bottom: 4px;
    position: sticky;
    top: 0px;
    background-color: ${(props) => props.tituloColuna ?? "white"};
    color: ${(props) => props.textoTituloColuna};
    font-weight: 500;
    border: 1px solid #e7e7e7;
    cursor: pointer;
`;

interface TableHeaderProps {
    colunas: any[];
    nomeTable?: string;
    buscarOrdenacao?: (field: string) => void;
    hoveredColumn: number | null;
    id: string | null;
    quebraTabelaEmbarque: any;
    quebraTabelaPedido: any;
    classeSelecionado?: string;
}

interface NomeColuna {
    nomeColuna: string;
}

interface QuebraTabelaEmbarque {
    quebraColunaEmbarque: boolean;
}

interface QuebraTabelaPedido {
    quebraColunaPedido: boolean;
}

function TableHeader({
    colunas,
    nomeTable,
    classeSelecionado,
    buscarOrdenacao,
    hoveredColumn,
    id,
    quebraTabelaEmbarque,
    quebraTabelaPedido,
}: TableHeaderProps) {
    const {
        profile,
        tabelaUsuario,
        contextoEmbarque,
    } = useProfile();

    const location = useLocation();

    const isRotaViagens = useMemo(() => {
        return (
            location.pathname.includes("/viagens/") ||
            location.pathname.includes("/faturamento")
        );
    }, [location.pathname]);

    if (!tabelaUsuario || !profile?.token) {
        return null;
    }

    return (
        <thead>
            {nomeTable ? (
                <tr>
                    {tabelaUsuario[nomeTable]?.map((head: any, index: number) => {
                        const nomeColuna: NomeColuna = colunas[index];
                        const isHovered: boolean = hoveredColumn === index;
                        if (head.visivel === "true" || head.visivel === true) {
                            const headsplit: string[] | undefined = nomeColuna?.nomeColuna?.split(" ");
                            if (head.field === "descricao") {
                                if (contextoEmbarque === "templateEmbarque") {
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {nomeColuna?.nomeColuna}
                                        </MotionTableTh>
                                    );
                                } else {
                                    return <Fragment key={uuidv4()} />;
                                }
                            }
                            if (headsplit?.length >= 0 && headsplit?.length <= 2) {
                                if (
                                    isRotaViagens &&
                                    id &&
                                    contextoEmbarque !== "templateEmbarque"
                                ) {
                                    if (
                                        (quebraTabelaEmbarque as QuebraTabelaEmbarque).quebraColunaEmbarque === true
                                    ) {
                                        const headsplit: string[] =
                                            nomeColuna?.nomeColuna.split(" ");
                                        return (
                                            <MotionTableTh
                                                key={`${nomeColuna.nomeColuna} -${index} `}
                                                onClick={() =>
                                                    buscarOrdenacao &&
                                                    buscarOrdenacao(head.field)
                                                }
                                                animate={{
                                                    backgroundColor: isHovered
                                                        ? "#cad4dcff"
                                                        : "#fff",
                                                    color: isHovered ? "#000" : "#555",
                                                }}
                                                transition={{
                                                    duration: 0.3,
                                                    ease: "easeInOut",
                                                }}
                                            >
                                                {headsplit[0]}
                                                <br />
                                                {headsplit[1]}
                                            </MotionTableTh>
                                        );
                                    } else {
                                        return (
                                            <MotionTableTh
                                                key={`${nomeColuna.nomeColuna} -${index} `}
                                                onClick={() =>
                                                    buscarOrdenacao &&
                                                    buscarOrdenacao(head.field)
                                                }
                                                animate={{
                                                    backgroundColor: isHovered
                                                        ? "#cad4dcff"
                                                        : "#fff",
                                                    color: isHovered ? "#000" : "#555",
                                                }}
                                                transition={{
                                                    duration: 0.3,
                                                    ease: "easeInOut",
                                                }}
                                            >
                                                {nomeColuna.nomeColuna}
                                            </MotionTableTh>
                                        );
                                    }
                                }
                                if ((quebraTabelaPedido as QuebraTabelaPedido)?.quebraColunaPedido) {
                                    const headsplit: string[] = nomeColuna?.nomeColuna.split(" ");
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {headsplit[0]}
                                            <br />
                                            {headsplit[1]}
                                        </MotionTableTh>
                                    );
                                } else {
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {nomeColuna.nomeColuna}
                                        </MotionTableTh>
                                    );
                                }
                            } else if (headsplit?.length === 3) {
                                if (
                                    isRotaViagens &&
                                    id &&
                                    contextoEmbarque !== "templateEmbarque"
                                ) {
                                    if (
                                        (quebraTabelaEmbarque as QuebraTabelaEmbarque).quebraColunaEmbarque === true
                                    ) {
                                        const headsplit: string[] =
                                            nomeColuna?.nomeColuna.split(" ");
                                        return (
                                            <MotionTableTh
                                                key={`${nomeColuna.nomeColuna} -${index} `}
                                                onClick={() =>
                                                    buscarOrdenacao &&
                                                    buscarOrdenacao(head.field)
                                                }
                                                animate={{
                                                    backgroundColor: isHovered
                                                        ? "#cad4dcff"
                                                        : "#fff",
                                                    color: isHovered ? "#000" : "#555",
                                                }}
                                                transition={{
                                                    duration: 0.3,
                                                    ease: "easeInOut",
                                                }}
                                            >
                                                {headsplit[0]} {headsplit[1]}
                                                <br />
                                                {headsplit[2]}
                                            </MotionTableTh>
                                        );
                                    } else {
                                        return (
                                            <MotionTableTh
                                                key={`${nomeColuna.nomeColuna} -${index} `}
                                                onClick={() =>
                                                    buscarOrdenacao &&
                                                    buscarOrdenacao(head.field)
                                                }
                                                animate={{
                                                    backgroundColor: isHovered
                                                        ? "#cad4dcff"
                                                        : "#fff",
                                                    color: isHovered ? "#000" : "#555",
                                                }}
                                                transition={{
                                                    duration: 0.3,
                                                    ease: "easeInOut",
                                                }}
                                            >
                                                {nomeColuna?.nomeColuna}
                                            </MotionTableTh>
                                        );
                                    }
                                }
                                if ((quebraTabelaPedido as QuebraTabelaPedido)?.quebraColunaPedido) {
                                    const headsplit: string[] =
                                        nomeColuna?.nomeColuna?.split(" ");
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {headsplit[0]} {headsplit[1]}
                                            <br />
                                            {headsplit[2]}
                                        </MotionTableTh>
                                    );
                                } else {
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {nomeColuna?.nomeColuna}
                                        </MotionTableTh>
                                    );
                                }
                            } else if (headsplit?.length === 4) {
                                if (
                                    !isRotaViagens &&
                                    id &&
                                    contextoEmbarque !== "templateEmbarque"
                                ) {
                                    if (
                                        (quebraTabelaEmbarque as QuebraTabelaEmbarque).quebraColunaEmbarque === true
                                    ) {
                                        const headsplit: string[] =
                                            nomeColuna.nomeColuna.split(" ");
                                        return (
                                            <MotionTableTh
                                                key={`${nomeColuna.nomeColuna} -${index} `}
                                                onClick={() =>
                                                    buscarOrdenacao &&
                                                    buscarOrdenacao(head.field)
                                                }
                                                animate={{
                                                    backgroundColor: isHovered
                                                        ? "#cad4dcff"
                                                        : "#fff",
                                                    color: isHovered ? "#000" : "#555",
                                                }}
                                                transition={{
                                                    duration: 0.3,
                                                    ease: "easeInOut",
                                                }}
                                            >
                                                {headsplit[0]} {headsplit[1]}
                                                <br />
                                                {headsplit[2]} {headsplit[3]}
                                            </MotionTableTh>
                                        );
                                    } else {
                                        return (
                                            <MotionTableTh
                                                key={`${nomeColuna.nomeColuna} -${index} `}
                                                onClick={() =>
                                                    buscarOrdenacao &&
                                                    buscarOrdenacao(head.field)
                                                }
                                                animate={{
                                                    backgroundColor: isHovered
                                                        ? "#cad4dcff"
                                                        : "#fff",
                                                    color: isHovered ? "#000" : "#555",
                                                }}
                                                transition={{
                                                    duration: 0.3,
                                                    ease: "easeInOut",
                                                }}
                                            >
                                                {nomeColuna?.nomeColuna}
                                            </MotionTableTh>
                                        );
                                    }
                                }
                                if ((quebraTabelaPedido as QuebraTabelaPedido).quebraColunaPedido === true) {
                                    const headsplit: string[] = nomeColuna.nomeColuna.split(" ");
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {headsplit[0]} {headsplit[1]}
                                            <br />
                                            {headsplit[2]} {headsplit[3]}
                                        </MotionTableTh>
                                    );
                                } else {
                                    return (
                                        <MotionTableTh
                                            key={`${nomeColuna.nomeColuna} -${index} `}
                                            onClick={() =>
                                                buscarOrdenacao &&
                                                buscarOrdenacao(head.field)
                                            }
                                            animate={{
                                                backgroundColor: isHovered
                                                    ? "#cad4dcff"
                                                    : "#fff",
                                                color: isHovered ? "#000" : "#555",
                                            }}
                                            transition={{
                                                duration: 0.3,
                                                ease: "easeInOut",
                                            }}
                                        >
                                            {nomeColuna?.nomeColuna}
                                        </MotionTableTh>
                                    );
                                }
                            } else {
                                return (
                                    <MotionTableTh
                                        key={`${nomeColuna.nomeColuna} -${index} `}
                                        onClick={() =>
                                            buscarOrdenacao &&
                                            buscarOrdenacao(head.field)
                                        }
                                        animate={{
                                            backgroundColor: isHovered
                                                ? "#cad4dcff"
                                                : "#fff",
                                            color: isHovered ? "#000" : "#555",
                                        }}
                                        transition={{
                                            duration: 0.3,
                                            ease: "easeInOut",
                                        }}
                                    >
                                        {nomeColuna?.nomeColuna}
                                    </MotionTableTh>
                                );
                            }
                        } else {
                            return <Fragment key={uuidv4()} />;
                        }
                    })}
                </tr>
            ) : (
                <tr key={`${classeSelecionado} `}>
                    {colunas &&
                        colunas.map((head, index) => {
                            const isHovered = hoveredColumn === index;
                            if (
                                location.pathname === "/faturamento" ||
                                location.pathname === "/aguardando-cte"
                            ) {
                                const headsplit = head.nomeColuna.split(" ");
                                return (
                                    <MotionTableTh
                                        key={`${head.nomeColuna} -${index} `}
                                        onClick={() =>
                                            buscarOrdenacao &&
                                            buscarOrdenacao(head.field)
                                        }
                                        animate={{
                                            backgroundColor: isHovered
                                                ? "#cad4dcff"
                                                : "#fff",
                                            color: isHovered ? "#000" : "#555",
                                        }}
                                        transition={{
                                            duration: 0.3,
                                            ease: "easeInOut",
                                        }}
                                    >
                                        {headsplit[0]}
                                        <br />
                                        {headsplit[1]}
                                    </MotionTableTh>
                                );
                            } else {
                                return (
                                    <MotionTableTh
                                        key={`${head.nomeColuna} -${index} `}
                                        onClick={() =>
                                            buscarOrdenacao &&
                                            buscarOrdenacao(head.field)
                                        }
                                        animate={{
                                            backgroundColor: isHovered
                                                ? "#cad4dcff"
                                                : "#fff",
                                            color: isHovered ? "#000" : "#555",
                                        }}
                                        transition={{
                                            duration: 0.3,
                                            ease: "easeInOut",
                                        }}
                                    >
                                        {head.nomeColuna}
                                    </MotionTableTh>
                                );
                            }
                        })}
                </tr>
            )}
        </thead>
    )
}

export default TableHeader;